import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { campaignPublicSelector } from 'primsell-shared-layer/features'
import { infoSelector } from 'features'

import { IPaymentInfo, PaymentInfoTypeE } from 'types'

import alreadyBoughtIcon from 'primsell-shared-layer/assets/icons/payment-info/already-bought.svg'
import * as S from './info-message.styles'

const InfoMessage = () => {
  const publicCampaignDetails = useSelector(campaignPublicSelector)
  const info = useSelector(infoSelector)

  const infoMessagesConfig: Record<PaymentInfoTypeE, IPaymentInfo> = useMemo(
    () => ({
      [PaymentInfoTypeE.LOYALTY_ALREADY_PURCHASED]: {
        image: alreadyBoughtIcon,
        message: `You have already purchased <br/> ${publicCampaignDetails?.name} NFT. <br/> This collection is limited to ${publicCampaignDetails?.maxAmountPerPurchase} item.`,
      },
    }),
    [publicCampaignDetails?.maxAmountPerPurchase, publicCampaignDetails?.name]
  )

  if (!info) {
    return <>{null}</>
  }

  return (
    <S.Container>
      <S.Image src={infoMessagesConfig[info].image} alt="info-message" />
      <S.MessageTypography color="grey">{infoMessagesConfig[info].message}</S.MessageTypography>
    </S.Container>
  )
}

export { InfoMessage }
